import type { ReactElement } from 'react';
import React from 'react';
import type { TableInstance } from 'react-table';

import { useIsMobileDevice } from '@swf/poker';

import type { MemberType } from './SearchBy';
import SearchBy from './SearchBy';
import styles from './Table.scss';

interface Props<T extends object> {
  instance: TableInstance<T>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  actionButtons: React.ComponentType<any>;
  type: MemberType;
}

const TopBar = <T extends object>({ instance, actionButtons, type }: Props<T>): ReactElement => {
  const isMobileDevice = useIsMobileDevice();
  const { headers } = instance;

  return (
    <div className={styles.topBarContainer}>
      {headers.map((column) => {
        if (column.id === 'selection' && !isMobileDevice) {
          return (
            <div className={styles.topBar} key={column.id}>
              <div>{column.render('Header')}</div>
              {React.createElement(actionButtons, { tableInstance: instance })}
            </div>
          );
        }

        return null;
      })}
      <SearchBy type={type} />
    </div>
  );
};

export default TopBar;
